import React from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Input from '@iso/components/uielements/input';
import IntlMessages from '@iso/components/utility/intlMessages';
import authAction from '@iso/redux/auth/actions';
import appAction from '@iso/redux/app/actions';
import logoLogin from '@iso/assets/images_main/logo_main.svg';
import melian_logo from '@iso/assets/images_main/logo_melian.svg';
import { getUserData } from '@iso/lib/helpers/utility';
import { api } from '@iso/config/site.config';

import SignInStyleWrapper from './SignIn.styles';

const { login } = authAction;
const { clearMenu } = appAction;

export default function SignIn() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.Auth.idToken);
  const { search } = useLocation();

  const [redirectToReferrer, setRedirectToReferrer] = React.useState(false);
  const [formID, setFormID] = React.useState('');
  React.useEffect(() => {
    if (getCode('code')) {
      // if signin?code=XXXXX&type=b64 is set
      getFormID();
      if (getCode('code') && formID) {
        setRedirectToReferrer(true);
      }
    } else {
      // normal login
      if (isLoggedIn) {
        setRedirectToReferrer(true);
      }
    }
  }, [isLoggedIn]);

  const getFormID = () => {
    if (getCode('code')) {
      const apiParams = {
        code: getCode('code'),
        type: getCode('type'),
      };
      api
        .get('/auth/getUserInfo', { params: apiParams })
        .then((res) => res.data)
        .then((res) => {
          if (res.success) {
            setFormID(res.formID);
            if (apiParams) {
              dispatch(login(apiParams));
            } else {
              dispatch(login());
            }
          }
        })
        .catch((error) => {});
    }
  };

  const getCode = (param) => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('type')) {
      return params.get(param);
    } else if (param === 'code') {
      let codeAr = search.split('code=');
      return codeAr[1];
    } else {
      return null;
    }
  };
  function handleLogin(e) {
    e.preventDefault();
    const userInfo = {
      email: document.getElementById('inputUserName').value || '',
      password: document.getElementById('inpuPassword').value || '',
      two_step_verification: getUserData().get('twoStepVerification'),
    };
    if (userInfo) {
      dispatch(login(userInfo));
    } else {
      dispatch(login());
    }
    dispatch(clearMenu());
    //history.push('/dashboard');
  }

  // if code param is set and formID exists then redirect to form
  let from =
    getCode('code') && formID !== '' ? '/dashboard/Forms/' + formID : '/twoStepVerification';

  if (redirectToReferrer) {
    return <Redirect to={from} />;
  }
  return (
    <SignInStyleWrapper className="isoSignInPage">
      <div className="isoLoginContentWrapper">
        <div className="isoLoginContent">
          <div className="isoLogoWrapper">
            <div>
              <div style={{ marginBottom: 5 }}>
                <img src={logoLogin} className="img-login" alt="" />
              </div>
            </div>
          </div>
          <div className="isoSignInForm">
            <form>
              <div className="isoInputWrapper">
                <Input
                  size="large"
                  placeholder="Email or Username"
                  autoComplete="true"
                  id="inputUserName"
                />
              </div>

              <div className="isoInputWrapper">
                <Input
                  size="large"
                  type="password"
                  placeholder="Password"
                  autoComplete="false"
                  id="inpuPassword"
                />
              </div>

              <div className="isoInputWrapper isoLeftRightComponent">
                <input
                  type="submit"
                  onClick={handleLogin}
                  value="Sign In"
                  className="button-login"
                />
              </div>
            </form>
            <div className="isoCenterComponent isoHelperWrapper">
              <Link to="/forgotpassword" className="isoForgotPass">
                <IntlMessages id="page.signInForgotPass" />
              </Link>
            </div>

            <div className="logoMelian">
              <p style={{ fontFamily: 'Poppins', fontWeight: '300', marginBottom: 13 }}>
                Powered by
              </p>
              <img src={melian_logo} width="155px" height="44px" alt="" />
            </div>
          </div>
        </div>
      </div>
    </SignInStyleWrapper>
  );
}
